import {useQuery} from "@tanstack/react-query";
import {readPresentInvAmount} from "../../../../../api/inventory/InvApi";

type Props = {
    id: number;
};

export const useReadPresentInvAmount = ({id}: Props) => {
    const {data} = useQuery({
        queryKey: ["readPresentInvAmount", id],
        queryFn: async () => await readPresentInvAmount(id),
        select: (res) => res?.data.result?.presentAmount ?? 0,
    });

    return {data};
};
